import React from 'react';

const SubHeading = ({ children, ...props }) => <h2 {...props}>{children}</h2>;

export default SubHeading;
